export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const FETCH_USER_BEGIN = 'FETCH_USER_BEGIN';
export const FETCH_ORGANIZATION_BEGIN = 'FETCH_ORGANIZATION_BEGIN';
export const FETCH_ORGANIZATION_SUCCESS = 'FETCH_ORGANIZATION_SUCCESS';
export const FETCH_ORGANIZATION_FAILURE = 'FETCH_ORGANIZATION_FAILURE';
export const SET_USER_ACTION = "SET_USER_ACTION";
export const UPDATE_ORGANIZATION_BEGIN_ACTION = "UPDATE_ORGANIZATION_BEGIN_ACTION";
export const UPDATE_ORGANIZATION_SUCCESS_ACTION = "UPDATE_ORGANIZATION_SUCCESS_ACTION";
export const UPDATE_ORGANIZATION_FAILURE_ACTION = "UPDATE_ORGANIZATION_FAILURE_ACTION";
export const FETCH_ORGANIZATION_STAT_BEGIN = "FETCH_ORGANIZATION_STAT_BEGIN";
export const FETCH_ORGANIZATION_STAT_SUCCESS = "FETCH_ORGANIZATION_STAT_SUCCESS";
export const FETCH_ORGANIZATION_STAT_FAILURE = "FETCH_ORGANIZATION_STAT_FAILURE";
export const FETCH_ORGANIZATION_SUBSCRIPTION_BEGIN = "FETCH_ORGANIZATION_SUBSCRIPTION_BEGIN";
export const FETCH_ORGANIZATION_SUBSCRIPTION_SUCCESS = "FETCH_ORGANIZATION_SUBSCRIPTION_SUCCESS";
export const FETCH_ORGANIZATION_SUBSCRIPTION_FAILURE = "FETCH_ORGANIZATION_SUBSCRIPTION_FAILURE";
export const FETCH_ORGANIZATION_DEPOSITS_BEGIN = "FETCH_ORGANIZATION_DEPOSITS_BEGIN";
export const FETCH_ORGANIZATION_DEPOSITS_SUCCESS = "FETCH_ORGANIZATION_DEPOSITS_SUCCESS";
export const FETCH_ORGANIZATION_DEPOSITS_FAILURE = "FETCH_ORGANIZATION_DEPOSITS_FAILURE";
export const setUser = (user) =>{
  return {
    type: SET_USER_ACTION,
    payload: user,
  }

} 

export const fetchOrganizationDepositsBegin = (organizationId) => ({
    type: FETCH_ORGANIZATION_DEPOSITS_BEGIN,
    payload: organizationId
});

export const fetchOrganizationDepositsSuccess = (deposits) => ({
    type: FETCH_ORGANIZATION_DEPOSITS_SUCCESS,
    payload: deposits
});

export const fetchOrganizationDepositsFailure = (error) => ({
    type: FETCH_ORGANIZATION_DEPOSITS_FAILURE,
    payload: error
});



export const fetchOrgSubscriptionBegin = (userId) => ({
    type: FETCH_ORGANIZATION_SUBSCRIPTION_BEGIN,
    payload: userId
});

export const fetchOrgSubscriptionSuccess = (subscription) => ({
    type: FETCH_ORGANIZATION_SUBSCRIPTION_SUCCESS,
    payload: subscription
});

export const fetchOrgSubscriptionFailure = (error) => ({
    type: FETCH_ORGANIZATION_SUBSCRIPTION_FAILURE,
    payload: error
});


export const fetchUserBegin = (userId) => ({
    type: FETCH_USER_BEGIN,
    payload: userId
});

export const fetchUserSuccess = (user) => ({
    type: FETCH_USER_SUCCESS,
    payload: user
});

export const fetchUserFailure = (error) => ({
    type: FETCH_USER_FAILURE,
    payload: error
});

export const fetchOrganizationBegin = (organizationId) => ({
    type: FETCH_ORGANIZATION_BEGIN,
    payload: organizationId
});

export const fetchOrganizationSuccess = (organization) => ({
    type: FETCH_ORGANIZATION_SUCCESS,
    payload: organization
});

export const fetchOrganizationFailure = (error) => ({
    type: FETCH_ORGANIZATION_FAILURE,
    payload: error
});

export const fetchOrganizationStatBegin = (organizationId) => ({
    type: FETCH_ORGANIZATION_STAT_BEGIN,
    payload: organizationId
});

export const fetchOrganizationStatSuccess = (organizationStat) => ({
    type: FETCH_ORGANIZATION_STAT_SUCCESS,
    payload: organizationStat
});

export const fetchOrganizationStatFailure = (error) => ({
    type: FETCH_ORGANIZATION_STAT_FAILURE,
    payload: error
});



export const updateOrganizationBegin = () => ({
    type: UPDATE_ORGANIZATION_BEGIN_ACTION,
    payload: undefined,
});

export const updateOrganizationSuccess = (organization) => ({
    type: UPDATE_ORGANIZATION_SUCCESS_ACTION,
    payload: organization
});

export const updateOrganizationFailure = (error) => ({
    type: UPDATE_ORGANIZATION_FAILURE_ACTION,
    payload: error
});

